<template>
  <div
    class="Nav__mobile button button_primary"
    @click="managePopupState({ popup: 'mobileMenu', _state: true })"
  >
    <a href="#" class="Nav__link">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 2H18M0 8H18M0 14H18" stroke="#FFFFFF" stroke-width="3" />
      </svg>
    </a>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "MobileButton",
  methods: mapMutations(["managePopupState"])
};
</script>

<style></style>
